import React from 'react';
import PropTypes from 'prop-types';
import logo from '../../../../assets/images/backjumbo_logo.svg';
import logoSisa from 'app-assets/images/back_sisa.svg';
import logoIcon from '../../../../assets/images/backjumbo_icon.svg';
import logoWhite from '../../../../assets/images/backjumbo_logo_white.svg';
import { urlSisa, urlBase } from './../../../components/utils/changeUrlSisa';
import logoIconSisa from '../../../../assets/images/engra.svg';
let changeUrl = false;

if (urlSisa() == urlBase()) {
    changeUrl = true;
}

// TODO: Mover al Layout
const Logo = ({ small, white, style }) => {
    return (
        <div className='logo-wrapper' style={style}>
            <img src={small ? (changeUrl ? logoIconSisa : logoIcon) : (white ? logoWhite : (changeUrl ? logoSisa : logo))} className='logo-img' />
        </div>
    );
};

const CustomLogo = props => <img src={changeUrl ? logoSisa : logo} {...props} />;

Logo.propTypes = {
    small: PropTypes.bool,
    style: PropTypes.object,
    white: PropTypes.bool
};

Logo.defaultProps = {
    small: false,
    white: false,
    style: {}
};

export {
    CustomLogo
};
export default Logo;
